import FlooringTableFilter from "./flooring-table-filter";

const FlooringFilters = {
  Table: FlooringTableFilter,
};

export default FlooringFilters;
